import { FaMountain } from "react-icons/fa";
import { defineType } from "sanity";

export default defineType({
  name: "cruiseWithConfidence",
  title: "Cruise with confidence",
  icon: FaMountain,
  type: "document",
  fields: [
    {
      name: "sectionTitle",
      title: "Section Title",
      type: "multilingualArrayString"
    },
    {
      name: "cards",
      title: "Cards",
      type: "array",
      of: [{ type: "cruiseWithConfidenceCard" }]
    }
  ],
  preview: {
    prepare(value) {
      return {
        title: "Cruise with confidence"
      };
    }
  }
});
